module.exports = __webpack_public_path__ + "img/consumos.fc9267d0.svg";